import script from "./IssuePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./IssuePanel.vue?vue&type=script&setup=true&lang=js"

import "./IssuePanel.vue?vue&type=style&index=0&id=5728c68f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5728c68f"]])

export default __exports__